/* Always use Shopify's cart total, never the quantity in an add-to-cart event. */
(() => {
  window.roCartCountController?.destroy();
  let timer = 0;
  let revision = 0;
  let pending = null;
  let destroyed = false;

  async function refresh(version) {
    const link = document.querySelector('[data-ro-cart-link]');
    if (!link || destroyed) return;
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    try {
      const response = await fetch(link.dataset.roCartUrl, {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (destroyed || version !== revision || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-ro-cart-count]').forEach(node => {
        const count = String(cart.item_count);
        if (node.textContent !== count) node.textContent = count;
      });
      document.dispatchEvent(new CustomEvent('ro:cart-count-updated'));
    } catch (_) {
      // Keep the last confirmed / server-rendered total if the connection fails.
    } finally {
      if (pending === controller) pending = null;
    }
  }

  function schedule() {
    if (destroyed) return;
    const version = ++revision;
    clearTimeout(timer);
    timer = setTimeout(() => refresh(version), 50);
  }
  function onVisible() { if (document.visibilityState === 'visible') schedule(); }
  const documentEvents = ['cart:update', 'ro:cart-changed', 'DOMContentLoaded', 'shopify:section:load'];
  documentEvents.forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  schedule();
  window.roCartCountController = {
    destroy() {
      destroyed = true;
      clearTimeout(timer);
      pending?.abort();
      documentEvents.forEach(name => document.removeEventListener(name, schedule));
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('pageshow', schedule);
      window.removeEventListener('focus', schedule);
    }
  };
})();
